var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4 12.4C3.65449 12.4 3.28174 12.4 2.98771 12.2782C2.59566 12.1158 2.28418 11.8043 2.12179 11.4123C2 11.1183 2 10.7455 2 10V4.56C2 3.66392 2 3.21587 2.17439 2.87362C2.32779 2.57256 2.57256 2.32779 2.87362 2.17439C3.21587 2 3.66392 2 4.56 2H10C10.7455 2 11.1183 2 11.4123 2.12179C11.8043 2.28418 12.1158 2.59566 12.2782 2.98771C12.4 3.28174 12.4 3.65449 12.4 4.4M10.16 18H15.44C16.3361 18 16.7841 18 17.1264 17.8256C17.4274 17.6722 17.6722 17.4274 17.8256 17.1264C18 16.7841 18 16.3361 18 15.44V10.16C18 9.26392 18 8.81587 17.8256 8.47362C17.6722 8.17256 17.4274 7.92779 17.1264 7.77439C16.7841 7.6 16.3361 7.6 15.44 7.6H10.16C9.26392 7.6 8.81587 7.6 8.47362 7.77439C8.17256 7.92779 7.92779 8.17256 7.77439 8.47362C7.6 8.81587 7.6 9.26392 7.6 10.16V15.44C7.6 16.3361 7.6 16.7841 7.77439 17.1264C7.92779 17.4274 8.17256 17.6722 8.47362 17.8256C8.81587 18 9.26392 18 10.16 18Z",
    stroke: "#4671F6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.fe0fe95d84a2919dac2e95a84a69a1a9.svg";
export { ForwardRef as ReactComponent };